//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  props: {
    post: { type: Object, required: true },
    showPrev: { type: Boolean, required: true },
    showNext: { type: Boolean, required: true }
  },
  computed: {
    ...mapGetters({
      getProductName: 'product/productName'
    }),
    productName () {
      return this.getProductName(this.post.sku)
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
